/**
 * @generated SignedSource<<63f7b6a50010836a7204925dabe3575b>>
 * @relayHash 4a6c34fbc178806dff339385ebe78cd0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d5e3df54167a0fcce23fec23e107035defc80a85d6c06a937f4996d02b1c2b96

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessBoardQuery } from './src_jiraBusinessBoardQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBusinessBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "d5e3df54167a0fcce23fec23e107035defc80a85d6c06a937f4996d02b1c2b96",
    "metadata": {},
    "name": "src_jiraBusinessBoardQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
